<script>
import { Inertia } from "@inertiajs/inertia";
import { Head, Link } from "@inertiajs/inertia-vue3";
import ProductBox from "@/Pages/Shared/ProductBox.vue";
import VerticalProductBox from "@/Pages/Shared/VerticalProductBox.vue";
import Loader from "@/Pages/Shared/Loader.vue";
import Layout from "@/Pages/Shared/Layout.vue";
import Comments from "@/Pages/Shared/Comments.vue";
import { Splide, SplideSlide, SplideTrack } from "@splidejs/vue-splide";
import "@splidejs/splide/dist/css/themes/splide-default.min.css";
import CategoryBox from "@/Pages/Shared/CategoryBox.vue";
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from "@headlessui/vue";

export default {
    components: {
        ProductBox,
        VerticalProductBox,
        Link,
        Head,
        Splide,
        SplideSlide,
        SplideTrack,
        CategoryBox,
        Loader,
        Comments,
        TransitionRoot,
        TransitionChild,
        Dialog,
        DialogPanel,
        DialogTitle
    },
    props: {
        sliders: Object,
        allProducts: Object,
        discounted: Object,
        mostRentedProducts: Object,
        category_anakucaklari: Object,
        category_besik: Object,
        category_kanguru: Object,
        category_bebekarabalari: Object,
        category_oyunoyuncak: Object,
        category_otokoltugu: Object,
        category_seyahat: Object,
        category_mamasandalyeleri: Object,
        category_cocukteknolojisi: Object,
        auth: Object
    },
    layout: Layout,
    data() {
        return {
            selectedSpeedCategory: 1,
            loaderActive: false,
            selectedSpeedCategoryProducts: this.category_anakucaklari,
            isOpen: true
        };
    },
    setup() {
        const options = {
            rewind: true,
            gap: "1rem",
            perPage: 1
        };

        return { options };
    },
    methods: {
        splidedArray(arr, size) {
            return arr.reduce((acc, e, i) => (i % size ? acc[acc.length - 1].push(e) : acc.push([e]), acc), []);
        },
        changeSpeedCategory(id) {
            // if not changed, return
            if (this.selectedSpeedCategory === id) return;

            this.selectedSpeedCategory = id;
            this.loaderActive = true;
            Inertia.reload({
                only: ["category_" + this.selectedSpeedCategory],
                onFinish: () => {
                    this.loaderActive = false;
                    this.selectedSpeedCategoryProducts = this["category_" + this.selectedSpeedCategory];
                },
                onSuccess: () => {
                    let categoryProducts = this["category_" + this.selectedSpeedCategory].items.element.products.data;
                    let categoryProductsDL = [];
                    categoryProducts.map((item, keys) => {
                        let product = {};
                        let subscribetionMonthsOrdered = [];
                        if (item.variants[0]?.prices.length > 0) subscribetionMonthsOrdered = Object.entries(item.variants[0]?.prices).sort(([, a], [, b]) => a.subscription_months.value - b.subscription_months.value);
                        let nonZeroPrices = item.variants[0]?.prices.filter((price) => price.price.value > 0);
                        subscribetionMonthsOrdered = subscribetionMonthsOrdered.filter((price) => price[1].price.value > 0);
                        let productPrice = subscribetionMonthsOrdered[+Object.keys(nonZeroPrices).length - 1]?.[1]?.price?.value / 100;

                        product.item_id = item.id;
                        product.item_name = item.attribute_data.name.tr;
                        product.price = productPrice;
                        product.item_brand = item.brand.name;
                        product.item_category = item.collections[0]?.attribute_data?.name?.tr;
                        product.item_category2 = item.collections[1]?.attribute_data?.name?.tr ?? "";
                        product.item_list_id = "HOME-KG";
                        product.item_list_name = "Homepage - Kategoriler " + this.selectedSpeedCategory + " List";
                        product.index = keys;
                        categoryProductsDL.push(product);
                    });
                    dataLayer.push({
                        event: "view_item_list",
                        ecommerce: {
                            item_list_id: "HOME-KG",
                            item_list_name: "Homepage - Kategoriler " + this.selectedSpeedCategory + " List",
                            items: categoryProductsDL
                        }
                    });
                }
            });
        },
        closeModal() {
            this.isOpen = false;
        },
        openModal() {
            this.isOpen = true;
        }
    },
    created() {
        Inertia.reload({
            only: ["allProducts", "mostRentedProducts", "discounted", "category_anakucaklari"],
            onSuccess: () => {
                let lastAddedProducts = this.allProducts.items.data;
                let lastAddedProductsDL = [];
                lastAddedProducts.map((item, keys) => {
                    let product = {};
                    let subscribetionMonthsOrdered = [];
                    if (item.variants[0]?.prices.length > 0) subscribetionMonthsOrdered = Object.entries(item.variants[0]?.prices).sort(([, a], [, b]) => a.subscription_months.value - b.subscription_months.value);
                    let nonZeroPrices = item.variants[0]?.prices.filter((price) => price.price.value > 0);
                    subscribetionMonthsOrdered = subscribetionMonthsOrdered.filter((price) => price[1].price.value > 0);
                    let productPrice = subscribetionMonthsOrdered[+Object.keys(nonZeroPrices).length - 1]?.[1]?.price?.value / 100;

                    product.item_id = item.id;
                    product.item_name = item.attribute_data.name.tr;
                    product.price = productPrice;
                    product.item_brand = item.brand.name;
                    product.item_category = item.collections[0]?.attribute_data?.name?.tr;
                    product.item_category2 = item.collections[1]?.attribute_data?.name?.tr ?? "";
                    product.item_list_id = "HOME-SEU";
                    product.item_list_name = "Homepage - Son Eklenen Ürünler List";
                    product.index = keys;
                    lastAddedProductsDL.push(product);
                });
                dataLayer.push({
                    event: "view_item_list",
                    ecommerce: {
                        item_list_id: "HOME-SEU",
                        item_list_name: "Homepage - Son Eklenen Ürünler List",
                        items: lastAddedProductsDL
                    }
                });

                let discountedProducts = this.discounted.items.data;
                let discountedProductsDL = [];
                discountedProducts.map((item, keys) => {
                    let product = {};
                    let subscribetionMonthsOrdered = [];
                    if (item.variants[0]?.prices.length > 0) subscribetionMonthsOrdered = Object.entries(item.variants[0]?.prices).sort(([, a], [, b]) => a.subscription_months.value - b.subscription_months.value);
                    let nonZeroPrices = item.variants[0]?.prices.filter((price) => price.price.value > 0);
                    subscribetionMonthsOrdered = subscribetionMonthsOrdered.filter((price) => price[1].price.value > 0);
                    let productPrice = subscribetionMonthsOrdered[+Object.keys(nonZeroPrices).length - 1]?.[1]?.price?.value / 100;

                    product.item_id = item.id;
                    product.item_name = item.attribute_data.name.tr;
                    product.price = productPrice;
                    product.item_brand = item.brand.name;
                    product.item_category = item.collections[0]?.attribute_data?.name?.tr;
                    product.item_category2 = item.collections[1]?.attribute_data?.name?.tr ?? "";
                    product.item_list_id = "HOME-IUL";
                    product.item_list_name = "Homepage - İndirimli Ürünler List";
                    product.index = keys;
                    discountedProductsDL.push(product);
                });
                dataLayer.push({
                    event: "view_item_list",
                    ecommerce: {
                        item_list_id: "HOME-IUL",
                        item_list_name: "Homepage - İndirimli Ürünler List",
                        items: discountedProductsDL
                    }
                });

                let mostRentedProducts = this.mostRentedProducts.items.data;
                let mostRentedProductsDL = [];
                mostRentedProducts.map((item, keys) => {
                    let product = {};
                    let subscribetionMonthsOrdered = [];
                    if (item.variants[0]?.prices.length > 0) subscribetionMonthsOrdered = Object.entries(item.variants[0]?.prices).sort(([, a], [, b]) => a.subscription_months.value - b.subscription_months.value);
                    let nonZeroPrices = item.variants[0]?.prices.filter((price) => price.price.value > 0);
                    subscribetionMonthsOrdered = subscribetionMonthsOrdered.filter((price) => price[1].price.value > 0);
                    let productPrice = subscribetionMonthsOrdered[+Object.keys(nonZeroPrices).length - 1]?.[1]?.price?.value / 100;

                    product.item_id = item.id;
                    product.item_name = item.attribute_data.name.tr;
                    product.price = productPrice;
                    product.item_brand = item.brand.name;
                    product.item_category = item.collections[0]?.attribute_data?.name?.tr;
                    product.item_category2 = item.collections[1]?.attribute_data?.name?.tr ?? "";
                    product.item_list_id = "HOME-ECKU";
                    product.item_list_name = "Homepage - En Çok Kiralanan Ürünler List";
                    product.index = keys;
                    mostRentedProductsDL.push(product);
                });
                dataLayer.push({
                    event: "view_item_list",
                    ecommerce: {
                        item_list_id: "HOME-ECKU",
                        item_list_name: "Homepage - En Çok Kiralanan Ürünler List",
                        items: mostRentedProductsDL
                    }
                });
            }
        });
    },
    computed: {
        splidedAllProducts() {
            return this.splidedArray(this.allProducts.items.data, 1);
        },
        splidedDiscounted() {
            // Take first 8 items than split them into 2
            return this.splidedArray(this.discounted.items.data.slice(0, 8), 1);
        }
    },
    watch: {
        // whenever question changes, this function will run
        category_anakucaklari(newRes, oldRes) {
            this.selectedSpeedCategoryProducts = newRes;
        }
    },
    mounted() {
        // calculate isOpen with cookie content
        // let cookies = document.cookie.split(";");
        // let isOpenCookie = null;
        // for (let i = 0; i < cookies.length; i++) {
        //     let cookie = cookies[i].split("=");
        //     if (cookie[0].trim() === "isOpen") {
        //         isOpenCookie = true;
        //     }
        // }
        //
        // if (isOpenCookie) {
        //     this.isOpen = false;
        // } else {
        //     this.isOpen = true;
        //     let date = new Date();
        //     date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
        //     const expires = "expires=" + date.toUTCString();
        //     document.cookie = "isOpen" + "=" + "true" + "; " + expires + "; path=/";
        // }
    }
};
</script>

<template>

    <Head title="Bebeğiniz İçin İhtiyacınız Olan Ürünleri Kiralayın | Kiralamini">
        <meta name="description" content="Kiralamini İle İhtiyacınız Olan Ürünü Uygun Fiyata Kiralayarak İstediğiniz Kadar Kullanın. Kullandığınız Kadar Ödeyin." />
    </Head>

    <main class="my-7 lg:my-12">
        <div class="mt-5 mb-[37px] hidden mts:block lg:hidden w-full mx-auto">
            <ul class="flex w-full space-x-3 justify-center text-xl leading-6.5 font-medium">
                <li class="p-0 m-0 text-base text-left text-gray-900 box-border whitespace-no-wrap">
                    <Link href="/hakkimizda">Nasıl Çalışır?</Link>
                </li>
                <li>
                    <svg viewBox="0 0 1 18.297" class="h-full">
                        <path class="stroke-neutral-400" d="M 0 0 L 0 18.296875"></path>
                    </svg>
                </li>
                <li class="p-0 m-0 text-base text-left text-gray-900 box-border whitespace-no-wrap">
                    <Link href="/hakkimizda">Kurumsal</Link>
                </li>
                <li>
                    <svg viewBox="0 0 1 18.297" class="h-full">
                        <path class="stroke-neutral-400" d="M 0 0 L 0 18.296875"></path>
                    </svg>
                </li>
                <li class="p-0 m-0 text-base text-left text-gray-900 box-border whitespace-no-wrap">
                    <Link href="/indirimli-urunler">İndirimli Ürünler</Link>
                </li>
            </ul>
        </div>

        <section class="-mt-7 lg:-mt-12 mb-4">
            <!-- Slider -->
            <div class="w-full mx-auto">
                <div class="sliderclass">
                    <splide :options="{ rewind: true, gap: '1rem', perPage: 1, arrows: false }" class="block mts:hidden ts:hidden">
                        <splide-slide v-for="item in sliders.filter((item) => item.type === 'mobil')">
                            <Link :href="item.url">
                            <img class="w-full" :src="item.media[0].original_url" alt="" loading="lazy" />
                            </Link>
                        </splide-slide>
                    </splide>

                    <splide :options="options" class="hidden mts:block ts:hidden">
                        <splide-slide v-for="item in sliders.filter((item) => item.type === 'tablet')">
                            <Link :href="item.url">
                            <img class="w-full" :src="item.media[0].original_url" alt="" loading="lazy" />
                            </Link>
                        </splide-slide>
                    </splide>

                    <splide :options="options" class="hidden mts:hidden ts:block">
                        <splide-slide v-for="item in sliders.filter((item) => item.type === 'desktop')">
                            <Link :href="item.url">
                            <img class="w-full" :src="item.media[0].original_url" alt="" loading="lazy" />
                            </Link>
                        </splide-slide>
                    </splide>

                    <!--                    <div>-->
                    <!--                        <svg class="w-full overflow-visible h-96 bg-[#61ba3f]">-->
                    <!--                            <rect rx="0" ry="0" x="0" y="0" width="1920" class="fill-current hidden md:block h-96"></rect>-->
                    <!--                        </svg>-->
                    <!--                        <img id="Mask_Group_70" src="../../images/Mask_Group_70.png" srcset="../../images/Mask_Group_70.png 1x, ../../images/Mask_Group_70@2x.png 2x">-->
                    <!--                        <div id="Group_115">-->
                    <!--                            <svg class="Ellipse_18">-->
                    <!--                                <ellipse id="Ellipse_18" rx="200" ry="200" cx="200" cy="200">-->
                    <!--                                </ellipse>-->
                    <!--                            </svg>-->
                    <!--                        </div>-->
                    <!--                        <img id="Mask_Group_63" src="../../images/Mask_Group_63.png" srcset="../../images/Mask_Group_63.png 1x, ../../images/Mask_Group_63@2x.png 2x">-->
                    <!--                    </div>-->
                </div>
            </div>
        </section>
        <section class="flex flex-row mx-auto max-w-kbmobile md:max-w-tablet ts:max-w-ts 2xl:max-w-7xl">
            <div class="w-12/12 md:w-3/4 lg:w-7/12 mx-auto">
                <ul class="flex text-xs space-x-1 lg:space-x-4 text-center mt-1">
                    <li class="w-1/5 md:w-1/3 lg:w-1/5">
                        <div class="flex flex-col">
                            <div class="h-10 md:h-14 self-center mb-3 flex items-end">
                                <img src="../../images/banner/minicare.png" class="h-10 md:h-14" />
                            </div>
                            <div class="text-3xs mts:text-xs leading-none">Mini Care</div>
                        </div>
                    </li>
                    <li class="w-1/5 md:w-1/3 lg:w-1/5">
                        <div class="flex flex-col">
                            <div class="h-10 md:h-14 self-center mb-3 flex items-end">
                                <svg class="w-10/12 lg:w-full max-h-14 mx-auto" id="Layer_2" viewBox="0 0 107.74 78.83">
                                    <g id="Layer_1-2">
                                        <g>
                                            <g>
                                                <rect class="cls-2" x="17.71" y="1" width="89.04" height="61.66" rx="14.15" ry="14.15" />
                                                <rect x="18.71" y="15.15" width="86.99" height="14.34" />
                                                <circle class="cls-1" cx="85.86" cy="44.17" r="8.66" />
                                                <circle class="cls-1" cx="74.62" cy="44.17" r="8.66" />
                                            </g>
                                            <g>
                                                <circle class="cls-3" cx="20.12" cy="58.71" r="19.12" />
                                                <polyline class="cls-4" points="10.55 58.71 17.71 68.53 29.75 47.27" />
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                            <div class="text-3xs mts:text-xs leading-none">Kart Limitin Sana Kalsın</div>
                        </div>
                    </li>
                    <li class="w-1/5 md:w-1/3 lg:w-1/5">
                        <div class="flex flex-col">
                            <div class="h-10 md:h-14 self-center mb-3 flex items-end">
                                <svg class="w-10/12 lg:w-full h-11 md:h-14 mx-auto" id="Layer_2" viewBox="0 0 148.11 137.57">
                                    <g id="Layer_1-2">
                                        <g>
                                            <g>
                                                <rect class="cls-1re" x="0" y="79.35" width="20.8" height="54.14" rx="2.9" ry="2.9" />
                                                <path class="cls-2" d="m11.13,128.75c-2.61.49-4.85-1.74-4.37-4.36.27-1.46,1.45-2.65,2.91-2.93,2.62-.5,4.89,1.76,4.38,4.37-.28,1.46-1.46,2.63-2.92,2.91Z" />
                                                <path class="cls-2"
                                                    d="m108.64,106.42l30.07-12.44c5.69-2.35,10.59,4.85,6.22,9.19-.07.07-.14.14-.22.21-.37.35-.78.65-1.23.89l-57.41,31.1c-1.22.66-2.65.85-4,.53l-56.9-13.48c-2.56-.61-4.36-2.89-4.36-5.51v-20.81c0-2.65,1.83-4.94,4.41-5.53l25.11-5.69c.93-.21,1.9-.18,2.81.08l46.7,13.37c.08.02.17.05.25.07.96.23,7.9,2.06,8.51,7.26.06.52.02,1.04-.08,1.55-.4,2.06-2.06,7.24-8.54,5.59l-26.8-6.4" />
                                            </g>
                                            <path class="cls-2re"
                                                d="m114.96,42.8c0-.5-.01-.99-.04-1.48-.04-.94.57-1.79,1.49-2.03l3.35-.88c1.07-.28,1.71-1.37,1.43-2.44l-2.07-7.91c-.28-1.07-1.37-1.71-2.44-1.43l-3.52.92c-.88.23-1.82-.15-2.25-.96-1.12-2.09-2.45-4.04-3.96-5.85-.6-.71-.6-1.75-.03-2.48l2.28-2.95c.68-.87.51-2.13-.36-2.81l-6.47-4.99c-.87-.67-2.13-.51-2.81.36l-2.34,3.04c-.56.73-1.55.99-2.38.61-2.1-.95-4.3-1.7-6.59-2.22-.9-.2-1.52-1.02-1.52-1.94v-3.87c0-1.1-.9-2-2-2h-8.18c-1.1,0-2,.9-2,2v3.87c0,.92-.63,1.74-1.53,1.94-2.12.48-4.17,1.16-6.12,2.01-.84.37-1.82.09-2.37-.64l-2.31-3.08c-.66-.88-1.92-1.06-2.8-.4l-6.54,4.9c-.88.66-1.06,1.92-.4,2.8l2.24,2.99c.56.74.54,1.78-.07,2.48-.93,1.07-1.79,2.2-2.58,3.38-.51.75-1.48,1.05-2.33.73l-3.45-1.27c-1.04-.38-2.18.15-2.57,1.19l-2.83,7.68c-.38,1.04.15,2.19,1.19,2.57l3.29,1.21c.88.32,1.42,1.21,1.29,2.14-.22,1.57-.34,3.17-.34,4.8,0,.22,0,.45,0,.67.02.92-.59,1.74-1.49,1.97l-3.32.87c-1.07.28-1.71,1.37-1.43,2.44l2.07,7.92c.28,1.07,1.37,1.71,2.44,1.43l3.13-.82c.9-.24,1.85.17,2.27,1,1.12,2.2,2.46,4.28,4.01,6.18.58.71.56,1.73,0,2.45l-1.93,2.5c-.68.87-.51,2.13.36,2.81l6.47,5c.87.67,2.13.51,2.81-.36l1.85-2.4c.57-.73,1.57-1,2.4-.6,2.23,1.06,4.6,1.88,7.06,2.44.9.2,1.52,1.02,1.52,1.94v3c0,1.1.9,2,2,2h8.18c1.1,0,2-.9,2-2v-3c0-.92.62-1.74,1.52-1.94,2.29-.52,4.5-1.27,6.6-2.22.84-.38,1.84-.11,2.4.63l1.81,2.43c.66.89,1.92,1.07,2.8.4l6.55-4.9c.88-.66,1.06-1.92.4-2.8l-1.89-2.52c-.55-.73-.55-1.75.04-2.45.97-1.16,1.87-2.39,2.69-3.68.5-.78,1.49-1.09,2.36-.77l3,1.11c1.04.38,2.19-.15,2.57-1.19l2.82-7.67c.38-1.04-.15-2.19-1.19-2.57l-3.17-1.17c-.86-.32-1.4-1.17-1.3-2.08.16-1.32.24-2.67.24-4.03Zm-22.17,12.18c-18,13.39-38.17-6.8-24.77-24.78.12-.17.28-.32.45-.45,17.99-13.38,38.16,6.79,24.77,24.78-.12.17-.28.32-.45.45Z" />
                                        </g>
                                    </g>
                                </svg>
                            </div>
                            <div class="text-3xs mts:text-xs leading-none">Hasarda %70 Garanti</div>
                        </div>
                    </li>
                    <li class="w-1/5 md:w-1/3 lg:w-1/5">
                        <div class="flex flex-col">
                            <div class="h-10 md:h-14 self-center mb-3 flex items-end">
                                <img src="../../images/banner/eniyidurumgarantisi.png" class="h-10 md:h-14" />
                            </div>
                            <div class="text-3xs mts:text-xs leading-none">En İyi Durum Garantisi</div>
                        </div>
                    </li>
                    <li class="w-1/5 md:w-1/3 lg:w-1/5">
                        <div class="flex flex-col">
                            <div class="h-10 md:h-14 self-center mb-3 flex items-end">
                                <svg class="w-10/12 lg:w-full max-h-14 mx-auto" id="Layer_2" viewBox="0 0 217.86 118.79">
                                    <g id="Layer_1-2">
                                        <g>
                                            <polyline class="cls-5eq"
                                                points="110.17 64.25 159.33 64.25 159.33 9.13 156.46 5.14 159.33 16.92 184.09 16.92 188.93 19.41 215.36 50.87 215.36 90.92 209.27 98.15 199.4 98.15 195.2 88.03 184.37 82.31 172.49 85.32 165.49 96.61 165.29 99.24 110.17 99.24 106.81 89.07 101.96 84.65 93.11 82.18 81.1 87.13 76.06 99.24 62.2 98.85 55.91 94.11 54.29 85.93 54.29 62.21" />
                                            <g>
                                                <path class="cls-4eq" d="m31.1,2.5h118.85c5.18,0,9.38,4.2,9.38,9.38v87.36" />
                                                <path class="cls-4eq" d="m33.68,48.6h9.83c5.96,0,10.79,4.83,10.79,10.79v29.06c0,5.96,4.83,10.79,10.79,10.79h10.98" />
                                                <path class="cls-4eq" d="m159.33,16.92h21.55c4.3,0,8.37,1.93,11.08,5.26l23.41,28.69v37.58c0,5.96-4.83,10.79-10.79,10.79h-5.17" />
                                                <polyline class="cls-4eq" points="165.29 99.24 159.33 99.24 110.17 99.24" />
                                                <line class="cls-2eq" x1="54.29" y1="64.25" x2="159.33" y2="64.25" />
                                                <line class="cls-2eq" x1="54.29" y1="78.83" x2="159.33" y2="78.83" />
                                                <circle class="cls-1eq" cx="93.11" cy="99.24" r="17.06" />
                                                <circle class="cls-1eq" cx="182.35" cy="99.24" r="17.06" />
                                                <line class="cls-3eq" x1="18.84" y1="16.92" x2="62.2" y2="16.92" />
                                                <line class="cls-3eq" y1="32.28" x2="43.36" y2="32.28" />
                                                <polyline class="cls-4eq" points="171.1 16.92 171.1 50.87 215.36 50.87" />
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                            <div class="text-3xs mts:text-xs leading-none">Ücretsiz Kargo</div>
                        </div>
                    </li>
                </ul>
            </div>
            <!--            <div class="w-3/12 hidden md:flex md:w-1/4 lg:w-5/12 flex-col items-start lg:ml-28">-->
            <!--                <div class="flex">-->
            <!--                    <h1 class=" text-xl md:text-2xl md:text-right lg:text-left lg:text-3xl  md:self-center">Seç! Beğen! Kirala!</h1>-->
            <!--                </div>-->
            <!--                <div class="flex md:w-full lg:w-auto md:justify-end lg:justify-start mt-2">-->
            <!--                    <button class="bg-black text-sm md:text-base text-white rounded-full py-1 md:py-2 px-2 md:px-4 self-center  whitespace-nowrap">Ürünlere Git</button>-->
            <!--                </div>-->
            <!--            </div>-->
        </section>

        <section class="mt-6 md:mt-4 py-1 md:py-9 bg-[#f8f8f8]">
            <div class="flex mx-auto flex-col max-w-kbmobile md:max-w-tablet ts:max-w-ts 2xl:max-w-7xl">
                <div class="flex w-full justify-between">
                    <div class="text-2xl md:text-3xl my-2 lg:my-0 mx-0 lg:mx-4 self-center text-center w-full md:w-auto text-minigreen">İndirimli Ürünler</div>
                    <div class="flex-1 ml-6 hidden md:flex">
                        <div class="flex-1 self-center border border-gray-200"></div>
                        <Link href="indirimli-urunler" class="cursor-pointer text-sm font-santralextrabold flex justify-center items-center border-2 rounded-full px-4 border-2 whitespace-nowrap md:ml-4 bg-white hover:bg-kbgreen hover:text-white">
                        Tümünü Gör</Link>
                    </div>
                </div>
                <div class="flex flex-col max-h-p-box space-x-1 pl-0 lg:pl-0 lg:p-0 lg:mt-9">
                    <Splide :has-track="false" aria-label="" :options="{ rewind: true, perPage: 4, pagination: false, breakpoints: { 640: { perPage: 1 }, 1100: { perPage: 2 }, 1270: { perPage: 3 } } }" v-if="discounted">
                        <SplideTrack>
                            <SplideSlide v-for="(productGroup, index) in splidedDiscounted" :key="index" class="flex">
                                <category-box v-for="(product, index) in productGroup" :product="product" :new-container-classes="`w-full`" :auth="auth" />
                            </SplideSlide>
                        </SplideTrack>
                        <div class="splide__arrows">
                            <button class="splide__arrow splide__arrow--prev !-left-9">
                                <svg class="" xmlns="http://www.w3.org/2000/svg" width="11.926" height="20.737" viewBox="0 0 11.926 20.737">
                                    <path id="Path_18" data-name="Path 18" d="M86.422,320.457a1.558,1.558,0,0,1,2.2,0l7.71,7.71,7.71-7.71a1.557,1.557,0,1,1,2.2,2.2l-8.811,8.811a1.558,1.558,0,0,1-2.2,0l-8.811-8.811A1.558,1.558,0,0,1,86.422,320.457Z"
                                        transform="translate(331.927 -85.966) rotate(90)" fill="#231f20" />
                                </svg>
                            </button>
                            <button class="splide__arrow splide__arrow--next !-right-9">
                                <svg class="rotate-180" xmlns="http://www.w3.org/2000/svg" width="11.926" height="20.737" viewBox="0 0 11.926 20.737">
                                    <path id="Path_18" data-name="Path 18" d="M86.422,320.457a1.558,1.558,0,0,1,2.2,0l7.71,7.71,7.71-7.71a1.557,1.557,0,1,1,2.2,2.2l-8.811,8.811a1.558,1.558,0,0,1-2.2,0l-8.811-8.811A1.558,1.558,0,0,1,86.422,320.457Z"
                                        transform="translate(331.927 -85.966) rotate(90)" fill="#231f20" />
                                </svg>
                            </button>
                        </div>
                    </Splide>
                    <div v-else>
                        <loader :active="true" message="Please wait 5 seconds" />
                    </div>
                </div>
                <div class="flex-1 ml-2 flex md:hidden justify-center">
                    <Link href="/indirimli-urunler" class="cursor-pointer border-3 rounded-full py-1.5 px-2 text-center mb-4 w-32 bg-white hover:bg-kbgreen hover:text-white font-santralextrabold text-sm"> Tümünü Gör</Link>
                </div>
            </div>
        </section>
        <section class="mt-6 flex flex-wrap mx-auto max-w-kbmobile md:max-w-tablet ts:max-w-ts 2xl:max-w-7xl justify-center items-stretch">
            <div class="text-3xl self-center text-center w-full text-minigreen">Neden Kiralamini</div>

            <div class="mt-4 w-full md:w-1/2 lg:w-1/4 px-2">
                <div class="bg-kb-mid-grey rounded-[30px] h-full w-full px-4 py-4">
                    <img src="../../images/banner/mesgul.png" class="w-1/2 mx-auto" />
                    <div class="mt-4 font-semibold text-xl text-center text-kbgreen min-h-[56px] flex items-start justify-center">Meşgulsünüz</div>
                    <div class="mt-4 text-sm text-black text-center font-santralregular">
                        İhtiyacınız olan bebek ürünlerini araştırmak, satın almak, bebeğiniz büyüdüğünde bu ürünle ne yapacağınızı düşünmekten daha önemli işleriniz var. Kullanılmış ürünleri bulmak ya da kullandığımız ürünü satmak için fiyat
                        pazarlığı yapmak, teslimatı koordine etmek ya da temizlemek de vakit kaybı ve uğraştırıcı. Kiralamini olarak
                        bunları sizin yerinize biz yapıyoruz!
                    </div>
                </div>
            </div>

            <div class="mt-4 w-full md:w-1/2 lg:w-1/4 px-2">
                <div class="bg-kb-mid-grey rounded-[30px] h-full w-full px-4 py-4">
                    <img src="../../images/banner/depolama.png" class="w-1/2 mx-auto" />
                    <div class="mt-4 font-semibold text-xl text-center text-kbgreen min-h-[56px] flex items-start justify-center">Depolama alanınız sınırlı</div>
                    <div class="mt-4 text-sm text-black text-center font-santralregular">
                        Bebeklerimiz büyüdükçe daha çok alana ihtiyaç duyarız. Kiralamini ile dolaplarınızı gerçekten kullandığınız şeylere ayırmanız mümkün. Bebeğinizi büyütürken ihtiyacınız olan ürünlere dönemsel olarak sahip olabilmeniz için
                        sistemimiz çok basit; ihtiyacın kadar kullan, kullandığın kadar öde, kolayca iade et.
                    </div>
                </div>
            </div>

            <div class="mt-4 w-full md:w-1/2 lg:w-1/4 px-2">
                <div class="bg-kb-mid-grey rounded-[30px] h-full w-full px-4 py-4">
                    <img src="../../images/banner/eniyi.png" class="w-1/2 mx-auto" />
                    <div class="mt-4 font-semibold text-xl text-center text-kbgreen min-h-[56px] flex items-start justify-center">En iyisini uygun fiyata istiyorsun</div>
                    <div class="mt-4 text-sm text-black text-center font-santralregular">
                        Ne kadar süre kullanacağımız belli değil, bu masrafa değer mi? Ya bebeğim beğenmezse? Bu ürüne gerçekten ihtiyacımız var mı? Kiralamini ile en iyi ve yeni ürünleri deneyebilir, sadece birkaç aylığına kullanabilir, kolayca
                        başka bir ürünle değiştirebilir ya da iade edebilirsin. Hem de çok makul fiyatlara!
                    </div>
                </div>
            </div>

            <div class="mt-4 w-full md:w-1/2 lg:w-1/4 px-2">
                <div class="bg-kb-mid-grey rounded-[30px] h-full w-full px-4 py-4">
                    <img src="../../images/banner/cevre.png" class="w-1/2 mx-auto" />
                    <div class="mt-4 font-semibold text-xl text-center text-kbgreen min-h-[56px] flex items-start justify-center">Çevreyi önemsiyorsun</div>
                    <div class="mt-4 text-sm text-black text-center font-santralregular">Ebeveyn olduğumuzda sürdürülebilir bir yaşam en büyük endişelerimizden birisi olur. Kiralamini ile bebek ürünlerinin uzun ve faydalı bir ömre sahip olduğundan
                        emin olabilirsin. Sadece bebeğin için değil, dünyamız için de daha iyisini yapabilirsin.</div>
                </div>
            </div>
        </section>

        <section class="mt-6 md:mt-4 py-1 md:py-9 bg-[#f8f8f8]">
            <div class="flex mx-auto flex-col max-w-kbmobile md:max-w-tablet ts:max-w-ts 2xl:max-w-7xl">
                <div class="flex w-full justify-between">
                    <div class="text-2xl md:text-3xl my-2 lg:my-0 mx-0 lg:mx-4 self-center text-center w-full md:w-auto text-minigreen">Son Eklenen Ürünler</div>
                    <div class="flex-1 ml-6 hidden md:flex">
                        <div class="flex-1 self-center border border-gray-200"></div>
                        <Link href="/kategoriler/tum-urunler"
                            class="cursor-pointer text-sm font-santralextrabold flex justify-center items-center border-2 rounded-full px-4 border-2 whitespace-nowrap md:ml-4 bg-white hover:bg-kbgreen hover:text-white"> Tümünü Gör</Link>
                    </div>
                </div>
                <div class="flex flex-col max-h-p-box space-x-1 pl-0 lg:pl-0 lg:p-0 lg:mt-9">
                    <Splide :has-track="false" aria-label="" :options="{ rewind: true, perPage: 4, pagination: false, breakpoints: { 640: { perPage: 1 }, 1100: { perPage: 2 }, 1270: { perPage: 3 } } }" v-if="allProducts">
                        <SplideTrack>
                            <SplideSlide v-for="(productGroup, index) in splidedAllProducts" :key="index" class="flex">
                                <category-box v-for="(product, index) in productGroup" :product="product" :new-container-classes="`w-full`" :auth="auth" />
                            </SplideSlide>
                        </SplideTrack>

                        <div class="splide__arrows">
                            <button class="splide__arrow splide__arrow--prev !-left-9">
                                <svg class="" xmlns="http://www.w3.org/2000/svg" width="11.926" height="20.737" viewBox="0 0 11.926 20.737">
                                    <path id="Path_18" data-name="Path 18" d="M86.422,320.457a1.558,1.558,0,0,1,2.2,0l7.71,7.71,7.71-7.71a1.557,1.557,0,1,1,2.2,2.2l-8.811,8.811a1.558,1.558,0,0,1-2.2,0l-8.811-8.811A1.558,1.558,0,0,1,86.422,320.457Z"
                                        transform="translate(331.927 -85.966) rotate(90)" fill="#231f20" />
                                </svg>
                            </button>
                            <button class="splide__arrow splide__arrow--next !-right-9">
                                <svg class="rotate-180" xmlns="http://www.w3.org/2000/svg" width="11.926" height="20.737" viewBox="0 0 11.926 20.737">
                                    <path id="Path_18" data-name="Path 18" d="M86.422,320.457a1.558,1.558,0,0,1,2.2,0l7.71,7.71,7.71-7.71a1.557,1.557,0,1,1,2.2,2.2l-8.811,8.811a1.558,1.558,0,0,1-2.2,0l-8.811-8.811A1.558,1.558,0,0,1,86.422,320.457Z"
                                        transform="translate(331.927 -85.966) rotate(90)" fill="#231f20" />
                                </svg>
                            </button>
                        </div>
                    </Splide>
                    <div v-else>
                        <loader :active="true" message="Please wait 5 seconds" />
                    </div>
                </div>
                <div class="flex-1 ml-2 flex md:hidden justify-center">
                    <Link href="/kategoriler/tum-urunler" class="cursor-pointer border-3 rounded-full py-1.5 px-2 text-center mb-4 w-32 bg-white hover:bg-kbgreen hover:text-white font-santralextrabold text-sm"> Tümünü Gör</Link>
                </div>
            </div>
        </section>

        <section class="mt-14">
            <div class="flex mx-auto flex-col max-w-kbmobile md:max-w-tablet ts:max-w-ts 2xl:max-w-7xl">
                <div class="flex">
                    <div class="text-2xl ts:text-3xl self-center md:text-left ts:mx-4 w-full lg:w-auto text-minigreen">En Çok Kiralanan Ürünler</div>
                    <div class="hidden md:flex md:w-2/3 flex-1 ml-6">
                        <div class="flex-1 self-center border-1 border-bordergray"></div>
                        <Link href="#" class="font-santralextrabold border text-sm whitespace-nowrap rounded-full py-1 flex justify-center items-center px-4 border-2 md:w-32 ml-4 hover:bg-kbgreen hover:text-white"> Tümünü Gör</Link>
                    </div>
                </div>
                <div class="w-full">
                    <Splide :has-track="false" aria-label="" class="w-full mt-5" :options="{ rewind: true, perPage: 2, pagination: false, pagination: false, breakpoints: { 640: { perPage: 1 }, 1100: { perPage: 2 } } }" v-if="mostRentedProducts">
                        <SplideTrack class="w-full">
                            <SplideSlide class="flex w-full" v-for="(product, index) in mostRentedProducts.items.data.slice(0, 4)">
                                <vertical-product-box :class="'!mx-2'" :product="product"></vertical-product-box>
                            </SplideSlide>
                        </SplideTrack>
                        <div class="splide__arrows">
                            <button class="splide__arrow splide__arrow--prev !-left-9">
                                <svg class="" xmlns="http://www.w3.org/2000/svg" width="11.926" height="20.737" viewBox="0 0 11.926 20.737">
                                    <path id="Path_18" data-name="Path 18" d="M86.422,320.457a1.558,1.558,0,0,1,2.2,0l7.71,7.71,7.71-7.71a1.557,1.557,0,1,1,2.2,2.2l-8.811,8.811a1.558,1.558,0,0,1-2.2,0l-8.811-8.811A1.558,1.558,0,0,1,86.422,320.457Z"
                                        transform="translate(331.927 -85.966) rotate(90)" fill="#231f20" />
                                </svg>
                            </button>
                            <button class="splide__arrow splide__arrow--next !-right-9">
                                <svg class="rotate-180" xmlns="http://www.w3.org/2000/svg" width="11.926" height="20.737" viewBox="0 0 11.926 20.737">
                                    <path id="Path_18" data-name="Path 18" d="M86.422,320.457a1.558,1.558,0,0,1,2.2,0l7.71,7.71,7.71-7.71a1.557,1.557,0,1,1,2.2,2.2l-8.811,8.811a1.558,1.558,0,0,1-2.2,0l-8.811-8.811A1.558,1.558,0,0,1,86.422,320.457Z"
                                        transform="translate(331.927 -85.966) rotate(90)" fill="#231f20" />
                                </svg>
                            </button>
                        </div>
                    </Splide>
                    <div v-else>
                        <loader :active="true" message="Please wait 5 seconds" />
                    </div>
                </div>
            </div>
        </section>
        <section class="hidden lg:block mt-3 bg-[#f8f8f8] py-5">
            <div class="flex mx-auto flex-col max-w-tablet ts:max-w-ts 2xl:max-w-7xl">
                <div class="flex px-4 md:px-0">
                    <div class="text-3xl self-center text-center w-full lg:w-auto text-minigreen">Kategorilere Göz At</div>
                    <div class="hidden md:flex md:w-2/3 flex-1 ml-6">
                        <div class="flex-1 self-center border border-gray-200"></div>
                    </div>
                </div>
                <div class="flex flex-wrap">
                    <div class="w-1/4 mt-4 max-h-[462px] overflow-y-scroll rounded-2lg">
                        <ul class="flex flex-col text-sm bg-white mx-4 rounded-2lg">
                            <li class="flex justify-between items-center group" @click="changeSpeedCategory('anakucaklari')">
                                <a :class="[selectedSpeedCategory == 1 ? 'bg-kbgreen' : '']"
                                    class="cursor-pointer w-full py-3 px-3 rounded-t-2lg active:bg-kbgreen focus:bg-kbgreen group-hover:bg-kbgreen group-hover:text-white focus:text-white active:text-white">
                                    <div class="flex items-center">
                                        <img src="../../images/category-icon/anakucagi.png" class="max-h-[35px] group-hover:invert" />
                                        <span class="ml-3 whitespace-nowrap text-base">Ana Kucağı</span>
                                    </div>
                                </a>
                            </li>
                            <li class="flex justify-between items-center group" @click="changeSpeedCategory('besik')">
                                <a class="cursor-pointer w-full py-3 px-3 active:bg-kbgreen focus:bg-kbgreen group-hover:bg-kbgreen group-hover:text-white focus:text-white active:text-white">
                                    <div class="flex items-center">
                                        <img src="../../images/category-icon/besik.png" class="max-h-[35px] group-hover:invert" />
                                        <span class="ml-3 whitespace-nowrap text-base">Beşik</span>
                                    </div>
                                </a>
                            </li>
                            <li class="flex justify-between items-center group" @click="changeSpeedCategory('kanguru')">
                                <a class="cursor-pointer w-full py-3 px-3 active:bg-kbgreen focus:bg-kbgreen group-hover:bg-kbgreen group-hover:text-white focus:text-white active:text-white">
                                    <div class="flex items-center">
                                        <img src="../../images/category-icon/kanguru.png" class="max-h-[35px] group-hover:invert" />
                                        <span class="ml-3 whitespace-nowrap text-base">Kanguru</span>
                                    </div>
                                </a>
                            </li>
                            <li class="flex justify-between items-center group" @click="changeSpeedCategory('bebekarabalari')">
                                <a class="cursor-pointer w-full py-3 px-3 active:bg-kbgreen focus:bg-kbgreen group-hover:bg-kbgreen group-hover:text-white focus:text-white active:text-white">
                                    <div class="flex items-center">
                                        <img src="../../images/category-icon/bebekarabasi.png" class="max-h-[35px] group-hover:invert" />
                                        <span class="ml-3 whitespace-nowrap text-base">Bebek Arabası</span>
                                    </div>
                                </a>
                            </li>
                            <li class="flex justify-between items-center group" @click="changeSpeedCategory('oyunoyuncak')">
                                <a class="cursor-pointer w-full py-3 px-3 active:bg-kbgreen focus:bg-kbgreen group-hover:bg-kbgreen group-hover:text-white focus:text-white active:text-white active">
                                    <div class="flex items-center">
                                        <img src="../../images/category-icon/oyun-oyuncak.png" class="max-h-[35px] group-hover:invert" />
                                        <span class="ml-3 whitespace-nowrap text-base">Oyun & Oyuncak</span>
                                    </div>
                                </a>
                            </li>
                            <li class="flex justify-between items-center group" @click="changeSpeedCategory('otokoltugu')">
                                <a class="cursor-pointer w-full py-3 px-3 active:bg-kbgreen focus:bg-kbgreen group-hover:bg-kbgreen group-hover:text-white focus:text-white active:text-white">
                                    <div class="flex items-center">
                                        <img src="../../images/category-icon/otokoltugu.png" class="max-h-[35px] group-hover:invert" />
                                        <span class="ml-3 whitespace-nowrap text-base">Oto Koltuğu</span>
                                    </div>
                                </a>
                            </li>
                            <li class="flex justify-between items-center group" @click="changeSpeedCategory('seyahat')">
                                <a class="cursor-pointer w-full py-3 px-3 active:bg-kbgreen focus:bg-kbgreen group-hover:bg-kbgreen group-hover:text-white focus:text-white active:text-white">
                                    <div class="flex items-center">
                                        <img src="../../images/category-icon/seyahat.png" class="max-h-[35px] group-hover:invert" />
                                        <span class="ml-3 whitespace-nowrap text-base">Seyahat</span>
                                    </div>
                                </a>
                            </li>
                            <li class="flex justify-between items-center group" @click="changeSpeedCategory('mamasandalyeleri')">
                                <a class="cursor-pointer w-full py-3 px-3 active:bg-kbgreen focus:bg-kbgreen group-hover:bg-kbgreen group-hover:text-white focus:text-white active:text-white">
                                    <div class="flex items-center">
                                        <img src="../../images/category-icon/mamasandalyesi.png" class="max-h-[35px] group-hover:invert" />
                                        <span class="ml-3 whitespace-nowrap text-base">Mama Sandalyesi</span>
                                    </div>
                                </a>
                            </li>
                            <li class="flex justify-between items-center group" @click="changeSpeedCategory('cocukteknolojisi')">
                                <a class="cursor-pointer w-full py-3 px-3 active:bg-kbgreen focus:bg-kbgreen group-hover:bg-kbgreen group-hover:text-white focus:text-white active:text-white">
                                    <div class="flex items-center">
                                        <img src="../../images/category-icon/cocuk-teknolojisi.png" class="max-h-[35px] group-hover:invert" />
                                        <span class="ml-3 whitespace-nowrap text-base">Çocuk Teknolojisi</span>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="w-3/4 mt-4">
                        <div class="pl-12 lg:pl-0 p-3 lg:p-0" :class="[loaderActive ? 'grid h-[462px] place-items-center' : '']">
                            <loader :active="loaderActive" message="Please wait 5 seconds" />
                            <Splide :has-track="false" aria-label="" :options="{ rewind: true, drag: true, arrows: false, perPage: 3, pagination: false, breakpoints: { 640: { perPage: 1 }, 1100: { perPage: 2 }, 1270: { perPage: 3 } } }">
                                <SplideTrack>
                                    <SplideSlide v-for="(product, index) in selectedSpeedCategoryProducts?.items?.element?.products?.data" class="flex">
                                        <category-box :product="product" :new-container-classes="`w-[100%]`" :auth="auth" v-if="!loaderActive" />
                                    </SplideSlide>
                                </SplideTrack>
                            </Splide>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="flex flex-wrap mx-auto max-w-kbmobile md:max-w-tablet ts:max-w-ts 2xl:max-w-7xl mt-16 w-full">
            <div class="text-3xl self-center text-center w-full text-minigreen">Kiralayan Müşterilerin Yorumları</div>
            <!--            <div class="text-2xl md:text-xl self-center text-center w-full mt-4">Bugüne Kadar Toplam <span-->
            <!--                class=""></span> Yorum </div>-->
            <div class="w-full flex justify-center mt-4">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="142.533 79.652 189.594 30.345" width="182.594" height="30.345">
                    <g id="Group_568" data-name="Group 568" transform="matrix(1, 0, 0, 1, 146.708847, 82.000595)">
                        <g id="star-solid" transform="translate(153.538 -2.432)" fill="none" stroke-linejoin="round">
                            <path
                                d="M28.647,14.4a1.852,1.852,0,0,0-1.076-3.336l-7.506-.284a.192.192,0,0,1-.167-.125L17.3,3.648a1.852,1.852,0,0,0-3.478,0l-2.586,7.031a.192.192,0,0,1-.167.125l-7.506.284a1.852,1.852,0,0,0-1.076,3.336L8.38,19.053a.192.192,0,0,1,.067.2L6.42,26.434a1.852,1.852,0,0,0,2.819,2.043l6.222-4.17a.184.184,0,0,1,.209,0l6.222,4.17a1.829,1.829,0,0,0,2.819-2L22.667,19.27a.183.183,0,0,1,.067-.2Z"
                                stroke="none" />
                            <path
                                d="M 15.56581592559814 4.712684631347656 L 13.11771202087402 11.36995697021484 C 12.81991195678711 12.17903709411621 12.07173156738281 12.74015617370605 11.21163177490234 12.79948616027832 C 11.19094085693359 12.80091667175293 11.17024230957031 12.80201721191406 11.14951133728027 12.80279731750488 L 4.008689880371094 13.07256507873535 L 9.616781234741211 17.48119735717773 C 10.30588150024414 18.02341651916504 10.60516166687012 18.92123794555664 10.37922096252441 19.76847839355469 C 10.37673187255859 19.77779769897461 10.37418174743652 19.7870979309082 10.37156105041504 19.79637718200684 L 8.45207405090332 26.5975456237793 L 14.34182357788086 22.64998245239258 C 14.70442581176758 22.40457725524902 15.12701416015625 22.27497673034668 15.56535148620605 22.27497673034668 C 16.00387954711914 22.27497673034668 16.42667579650879 22.40470314025879 16.78940200805664 22.65032577514648 L 22.66341590881348 26.58734130859375 L 20.74460220336914 19.82059097290039 C 20.4981746673584 18.96349334716797 20.80209732055664 18.03650093078613 21.50568389892578 17.49121475219727 L 27.13162803649902 13.04759216308594 L 19.98955154418945 12.77777671813965 C 19.96883010864258 12.77699661254883 19.9481315612793 12.7758960723877 19.92745208740234 12.77446746826172 C 19.06741142272949 12.71515655517578 18.31924057006836 12.15408706665039 18.02266120910645 11.34850692749023 L 15.56581592559814 4.712684631347656 M 15.56536102294922 2.432346343994141 C 16.3427619934082 2.432346343994141 17.03738021850586 2.917966842651367 17.30434036254883 3.648096084594727 L 19.89824104309082 10.65409660339355 C 19.92435073852539 10.72501754760742 19.98965072631836 10.77400779724121 20.0650520324707 10.77920722961426 L 27.57149124145508 11.06278610229492 C 28.36390113830566 11.07572746276855 29.06021118164062 11.5915470123291 29.30345153808594 12.34580612182617 C 29.54671096801758 13.10007667541504 29.28295135498047 13.92551612854004 28.64740180969238 14.39897727966309 L 22.73400115966797 19.06964683532715 C 22.67178153991699 19.11562728881836 22.64510154724121 19.19569778442383 22.66728210449219 19.26981735229492 L 24.71070098876953 26.47599792480469 C 24.92720031738281 27.2225170135498 24.64986038208008 28.02444648742676 24.0184326171875 28.47771644592285 C 23.38178253173828 28.93046569824219 22.52827453613281 28.93046760559082 21.89161109924316 28.47771644592285 L 15.66961097717285 24.30746650695801 C 15.60686111450195 24.26414680480957 15.52384185791016 24.26414680480957 15.46110153198242 24.30746650695801 L 9.239101409912109 28.47771644592285 C 8.594064712524414 28.9152660369873 7.744083404541016 28.90202713012695 7.112991333007812 28.44457626342773 C 6.481901168823242 27.98713684082031 6.204860687255859 27.18345642089844 6.420021057128906 26.43428802490234 L 8.446750640869141 19.25313568115234 C 8.466501235961914 19.1790771484375 8.440271377563477 19.10036659240723 8.380031585693359 19.0529670715332 L 2.49165153503418 14.42399787902832 C 1.856111526489258 13.95053672790527 1.592351913452148 13.12509727478027 1.835601806640625 12.37083625793457 C 2.078851699829102 11.61656761169434 2.775161743164062 11.10074615478516 3.567581176757812 11.08780670166016 L 11.07401084899902 10.80422782897949 C 11.14940071105957 10.79902648925781 11.21471214294434 10.75003623962402 11.24081230163574 10.67912673950195 L 13.82636070251465 3.648096084594727 C 14.09332084655762 2.917966842651367 14.78795051574707 2.432346343994141 15.56536102294922 2.432346343994141 Z"
                                style="fill: #a2d45e; stroke: #a2d45e" />
                        </g>
                        <path id="star-solid-2" data-name="star-solid"
                            d="M28.647,14.4a1.852,1.852,0,0,0-1.076-3.336l-7.506-.284a.192.192,0,0,1-.167-.125L17.3,3.648a1.852,1.852,0,0,0-3.478,0l-2.586,7.031a.192.192,0,0,1-.167.125l-7.506.284a1.852,1.852,0,0,0-1.076,3.336L8.38,19.053a.192.192,0,0,1,.067.2L6.42,26.434a1.852,1.852,0,0,0,2.819,2.043l6.222-4.17a.184.184,0,0,1,.209,0l6.222,4.17a1.829,1.829,0,0,0,2.819-2L22.667,19.27a.183.183,0,0,1,.067-.2Z"
                            transform="translate(114.717 -2.432)" fill="#a2d45e" />
                        <path id="star-solid-3" data-name="star-solid"
                            d="M28.647,14.4a1.852,1.852,0,0,0-1.076-3.336l-7.506-.284a.192.192,0,0,1-.167-.125L17.3,3.648a1.852,1.852,0,0,0-3.478,0l-2.586,7.031a.192.192,0,0,1-.167.125l-7.506.284a1.852,1.852,0,0,0-1.076,3.336L8.38,19.053a.192.192,0,0,1,.067.2L6.42,26.434a1.852,1.852,0,0,0,2.819,2.043l6.222-4.17a.184.184,0,0,1,.209,0l6.222,4.17a1.829,1.829,0,0,0,2.819-2L22.667,19.27a.183.183,0,0,1,.067-.2Z"
                            transform="translate(75.896 -2.432)" fill="#a2d45e" />
                        <path id="star-solid-4" data-name="star-solid"
                            d="M28.647,14.4a1.852,1.852,0,0,0-1.076-3.336l-7.506-.284a.192.192,0,0,1-.167-.125L17.3,3.648a1.852,1.852,0,0,0-3.478,0l-2.586,7.031a.192.192,0,0,1-.167.125l-7.506.284a1.852,1.852,0,0,0-1.076,3.336L8.38,19.053a.192.192,0,0,1,.067.2L6.42,26.434a1.852,1.852,0,0,0,2.819,2.043l6.222-4.17a.184.184,0,0,1,.209,0l6.222,4.17a1.829,1.829,0,0,0,2.819-2L22.667,19.27a.183.183,0,0,1,.067-.2Z"
                            transform="translate(37.075 -2.432)" fill="#a2d45e" />
                        <path id="star-solid-5" data-name="star-solid"
                            d="M28.647,14.4a1.852,1.852,0,0,0-1.076-3.336l-7.506-.284a.192.192,0,0,1-.167-.125L17.3,3.648a1.852,1.852,0,0,0-3.478,0l-2.586,7.031a.192.192,0,0,1-.167.125l-7.506.284a1.852,1.852,0,0,0-1.076,3.336L8.38,19.053a.192.192,0,0,1,.067.2L6.42,26.434a1.852,1.852,0,0,0,2.819,2.043l6.222-4.17a.184.184,0,0,1,.209,0l6.222,4.17a1.829,1.829,0,0,0,2.819-2L22.667,19.27a.183.183,0,0,1,.067-.2Z"
                            transform="translate(-1.746 -2.432)" fill="#a2d45e" />
                    </g>
                    <path id="path-2" data-name="star-solid"
                        d="M 263.007 35.705 C 263.029 35.772 258.516 32.905 259.685 33.722 C 263.176 36.164 259.58 14.045 261.27 14.016 C 260.758 14.078 264.616 20.627 264.59 20.556 L 261.992 13.549 C 261.502 12.21 259.746 11.904 258.832 12.998 C 258.695 13.162 258.587 13.349 258.514 13.549 L 255.928 20.58 C 255.902 20.651 255.836 20.7 255.761 20.705 L 248.255 20.989 C 246.83 21.013 245.965 22.572 246.699 23.794 C 246.823 24.001 246.986 24.181 247.179 24.325 L 253.072 28.954 C 253.132 29.001 253.159 29.08 253.139 29.154 L 251.112 36.335 C 250.72 37.706 251.958 38.987 253.342 38.641 C 253.552 38.589 253.751 38.5 253.931 38.378 L 260.153 34.208 C 260.216 34.165 260.299 34.165 260.362 34.208 C 260.362 34.208 258.858 33.152 263.007 35.705 Z"
                        fill="#a2d45e" transform="matrix(1, 0, 0, 1, 55.493668, 69.600685)" />
                </svg>
            </div>
            <div class="text-xl md:text-base self-center text-kbblue text-center w-full mt-4 md:mt-2">Mükemmel</div>
            <Comments></Comments>
        </section>
    </main>
    <TransitionRoot appear :show="false" as="template">
        <Dialog as="div" @close="closeModal" class="relative z-10">
            <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0" enter-to="opacity-100" leave="duration-200 ease-in" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-black bg-opacity-25" />
            </TransitionChild>
            <div class="fixed inset-0 overflow-y-auto">
                <div class="flex min-h-full items-center justify-center p-4 text-center">
                    <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0 scale-95" enter-to="opacity-100 scale-100" leave="duration-200 ease-in" leave-from="opacity-100 scale-100" leave-to="opacity-0 scale-95">
                        <DialogPanel class="max-w-[350px] md:max-w-[750px] transform rounded-sm bg-white z-70 text-left align-middle shadow-xl transition-all flex flex-col justify-center items-center px-4 lg:px-5 py-3 lg:py-5">
                            <div class="font-santralextrabold text-lg md:text-xl text-kbgreen text-center mb-4">
                                Kiralamini ailesi olarak Kurban Bayramınızı kutluyoruz!
                            </div>
                            <div class="font-santralregular text-sm 2xl:text-base text-black text-start mb-4">
                                Müşteri Hizmetleri ekibimiz çağrılarınıza ve maillerinize <b>01.06.2026</b> tarihinden itibaren destek vermeye devam edecek.<br /><br />

                                <b>25.05.2026 18:00</b> tarihinden itibaren vereceğiniz siparişler <b>01.06.2026</b> tarihinden itibaren işleme alınacaktır.<br /><br />

                                Onaylanan siparişler için teslimat sürelerinin ortalama 5 iş günü olduğunu hatırlatır, bugünden itibaren vereceğiniz tüm siparişlerde bu sürenin 01.06.2026 tarihinde başlayacağını belirtmek isteriz.<br /><br />

                                Herkese iyi bayramlar!
                            </div>


                            <div class="font-santralextrabold absolute top-2 right-2 cursor-pointer px-1 text-base bg-white rounded-sm" @click="closeModal">X</div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
